module.exports = __webpack_public_path__ + "img/cluster80.dd84c492.png";